import { render, staticRenderFns } from "./AIChatSettings.vue?vue&type=template&id=cd364b3e&scoped=true"
import script from "./AIChatSettings.vue?vue&type=script&lang=js"
export * from "./AIChatSettings.vue?vue&type=script&lang=js"
import style0 from "./AIChatSettings.vue?vue&type=style&index=0&id=cd364b3e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd364b3e",
  null
  
)

export default component.exports